<template>
  <div :class="[ 'c-multi-input', { '-validation': !!validation, '-label-left': labelLeft } ]">
    <c-input
      v-bind="$attrs"
      class="select"
      :validation="validation"
      :label-left="labelLeft"
      v-model="internalValue"
      @keydown.enter.prevent="onInputEnter"
      @keydown.tab="onInputEnter"
      @blur="onInputEnter"
    />

    <item-list
      v-if="(value || []).length"
      v-bind="$attrs"
      class="selected"
      :items="value"
      :display-by="displayBy"
      @remove="onRemove"
    />
  </div>
</template>

<script>
import { CInput } from '@convenia/components/CInput'
import CommonMixin from './fragments/CommonMixin'
import ItemList from './fragments/ItemList.vue'

export default {
  name: 'CMultiInput',

  components: { ItemList, CInput },

  mixins: [ CommonMixin ],

  emits: [
    'remove',
    'add',
    'update:modelValue'
  ]
}
</script>

<style lang="scss">
.c-multi-input {
  display: flex;
  flex-direction: column;
}
</style>
